export default "__VITE_ASSET__BWTZndz0__"